import {
    Module,
    VuexModule,
    getModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import store from '~common-store';
import { DeviceGroupState, IDeviceGroup } from '~/interfaces/devicegroup.interface';
import apiService from '~/services/api.service';

@Module({ dynamic: true, store, name: 'devicegroup', namespaced: true })
class DeviceGroup extends VuexModule implements DeviceGroupState {
    deviceGroups: IDeviceGroup[] = [];
    deviceIds = [] as string[];
    areDeviceGroupsLoading = false;

    @Action
    async getDeviceGroups(type: string) {
        try {
            this.setAreDeviceGroupsLoading(true);
            const deviceGroups = (await apiService.admingetdevicegroups({ type }, `failed to get device groups for type: ${type}`)).data.body;
            this.context.commit('SET_DEVICE_GROUPS', deviceGroups);
        } catch (error) {
            this.context.commit('SET_DEVICE_GROUPS', []);
        } finally {
            this.setAreDeviceGroupsLoading(false);
        }
    }

    @Action
    setAreDeviceGroupsLoading(value: boolean) {
        this.context.commit('SET_ARE_DEVICE_GROUPS_LOADING', value);
    }

    @Mutation
    SET_DEVICE_GROUPS(deviceGroups: IDeviceGroup[]) {
        this.deviceGroups = deviceGroups;
    }

    @Mutation
    SET_ARE_DEVICE_GROUPS_LOADING(value: boolean) {
        this.areDeviceGroupsLoading = value;
    }

    get deviceGroupById() {
        return (id: string) => this.deviceGroups.find((deviceGroup) => deviceGroup._id.$id === id);
    }

}

export const DeviceGroupModule = getModule(DeviceGroup);
